<template>
<div>
  <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
    <div class="title-h3">스케줄 등록</div>
    <div>
      <el-button class="mr-r4" @click="clickPreStep">전단계</el-button>
      <el-button type="primary" @click="clickNextStep">다음단계</el-button>
    </div>
  </el-row>
  <hr class="mr-b20" style="margin-top:0;" />
  <el-row>
    <el-col :span="12">
      <el-row type="flex" justify="space-between" class="mr-b20" >
        <div class="title-h4">
          스케줄 등록 여부
        </div>
        <el-switch v-model="checkScheduleFlag"></el-switch>
      </el-row>
      <div v-show="checkScheduleFlag">
        <el-form :model="scheduleFormData" label-position="top" ref="scheduleForm" :rules="rules">
          <div class="mr-b20">
            <el-form-item label="스케줄 이름" prop="scheduleName">
              <el-input v-model="scheduleFormData.scheduleName" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </div>
          <w-period-setting-component ref="periodSettingCmp" class="mr-b20"/>
        </el-form>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import WPeriodSettingComponent from '@/views/settings/components/PeriodSettingComponent';

export default {
  name: 'WScheduleSetting',
  components: {
    WPeriodSettingComponent,
  },
  props: {
    scheduleData: Object,
  },
  data() {
    return {
      isUpdateFlag: false,
      checkScheduleFlag: false,
      scheduleFormData: {},
      rules: {
        scheduleName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
    };
  },
  mounted() {
    if (!isNil(this.scheduleData)) {
      if (!isNil(this.scheduleData.scheduleId)) {
        this.isUpdateFlag = true;
      }
    }
    this.loadData();
  },
  methods: {
    loadData() {
      if (!isNil(this.scheduleData)) {
        const scheduleData = this.scheduleData;
        const checkScheduleFlag = scheduleData.checkScheduleFlag;
        this.checkScheduleFlag = checkScheduleFlag;
        if (checkScheduleFlag) {
          this.scheduleFormData = scheduleData;
          this.$refs.periodSettingCmp.setPeriodSettingData(scheduleData);
        }
      }
    },
    clickNextStep() {
      const tempData = {};
      tempData.checkScheduleFlag = this.checkScheduleFlag;
      if (this.checkScheduleFlag) {
        this.$refs.scheduleForm
          .validate()
          .then((response) => {
            if (response) {
              const scheduleFormData = this.scheduleFormData;
              tempData.scheduleName = scheduleFormData.scheduleName;
              const schedulePeriodData = this.$refs.periodSettingCmp.getPeriodSettingData();
              Object.assign(tempData, schedulePeriodData);
              if (this.isUpdateFlag) {
                tempData.scheduleId = this.scheduleData.scheduleId;
              }
              this.$emit('click-next-step', tempData, 'scheduleData');
            }
          })
          .catch(() => {});
      } else {
        this.$emit('click-next-step', tempData, 'scheduleData');
      }
    },
    clickPreStep() {
      const tempData = {};
      tempData.checkScheduleFlag = this.checkScheduleFlag;
      if (this.checkScheduleFlag) {
        const scheduleFormData = this.scheduleFormData;
        tempData.scheduleName = scheduleFormData.scheduleName;
        const schedulePeriodData = this.$refs.periodSettingCmp.getPeriodSettingData();
        Object.assign(tempData, schedulePeriodData);
        if (this.isUpdateFlag) {
          tempData.scheduleId = this.scheduleData.scheduleId;
        }
      }
      this.$emit('click-pre-step', tempData, 'scheduleData');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/components/ScheduleSetting.vue